import { OptionKV } from "~styled/selector/Selector";

export const TODOS = "Pendiente,PendienteCompania,DatosIncompletos";
export const PENDIENTE = "Pendiente";
export const PENDIENTECOMPANIA = "PendienteCompania";
export const DATOSINCOMPLETOS = "DatosIncompletos";

const estadosSolicitudEmisionOptions: Record<string, string> = {
  [TODOS]: "Todos",
  [PENDIENTE]: "Pendiente de Emisión",
  [PENDIENTECOMPANIA]: "Pendiente en Compañía",
  [DATOSINCOMPLETOS]: "Datos Incompletos",
};

const estadosSolicitudEmision: string[] = [
  PENDIENTE,
  PENDIENTECOMPANIA,
  DATOSINCOMPLETOS,
];

const estadosSolicitudEmisionFilter: OptionKV<string>[] = [
  { label: estadosSolicitudEmisionOptions[TODOS], value: TODOS },
  {
    label: estadosSolicitudEmisionOptions[PENDIENTE],
    value: PENDIENTE,
  },
  {
    label: estadosSolicitudEmisionOptions[PENDIENTECOMPANIA],
    value: PENDIENTECOMPANIA,
  },
  {
    label: estadosSolicitudEmisionOptions[DATOSINCOMPLETOS],
    value: DATOSINCOMPLETOS,
  },
];

export {
  estadosSolicitudEmisionOptions,
  estadosSolicitudEmision,
  estadosSolicitudEmisionFilter,
};
